import { Typography } from "@/frontend/shared/ui/Typography";

export function InnoveraBlockNoData() {
  return (
    <Typography variant="body-2" color="greyscale900">
      No public data found
    </Typography>
  );
}
